import React from "react";
import "./ClinicalProfessionalSubmissionConfirmation.scss";

const SubmissionConfirmation = () => {
  const onClose = () => {
    window.location.href = "https://trshealthcare.com/";
  };

  return (
     <div className="modal-backdrop">
      <div className="modal-content">
        <h2 className="modal-title">Submitted. Thank you!</h2>
        <button onClick={onClose} className="modal-button">OK</button>
      </div>
    </div>
  );
};

export default SubmissionConfirmation;